export default "__VITE_ASSET__56b18ee6__"